import clsx from "clsx";
import React from "react";
import { LabelProps } from "./FormFields.interfaces";
import styles from "./FormFields.module.scss";

const Label: React.FC<LabelProps> = ({
  htmlFor,
  text,
  isOptional,
  disabled,
}) => (
  <>
    {text ? (
      <div className={styles["form-label"]}>
        <label
          htmlFor={htmlFor}
          className={clsx(styles.label, disabled && styles.disabled)}
        >
          {text}
          {isOptional && <span className="optional-field"> (optional)</span>}
        </label>
      </div>
    ) : null}
  </>
);

export default Label;
